// @flow
import styled from '@emotion/styled';
import { SPACING, BORDER_RADIUS, color } from '@tablekit/theme';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faEnvelopeOpen } from '@fortawesome/pro-solid-svg-icons/faEnvelopeOpen';
import { LAPTOP_BREAKPOINT, MOBILE_BREAKPOINT } from 'utils/theme';

const ShareButtonsPositioner = styled.div`
  display: flex;

  @media ${MOBILE_BREAKPOINT} {
    flex-direction: row;
    justify-content: center;
  }
  @media ${LAPTOP_BREAKPOINT} {
    position: absolute;
    left: -${SPACING.L8};
    top: 0;
    border-radius: ${BORDER_RADIUS}px;
    background: ${color('primary')};
    flex-direction: column;
  }
`;

const IconButton = styled(OutboundLink)`
  padding: ${SPACING.L1};
  color: white;
  > svg {
    width: 25px !important;
    height: 25px !important;
  }

  @media ${MOBILE_BREAKPOINT} {
    margin: 0 ${parseInt(SPACING.L3, 10) / 2}px;
    padding: ${SPACING.L1};
    background-color: ${color('primary')};
    border-radius: ${BORDER_RADIUS}px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const ShareButtons = () => {
  let href = '';
  let title = '';
  if (typeof window !== 'undefined') {
    href = encodeURIComponent(window.location.href);
    title = encodeURIComponent(document.title);
  }
  return (
    <ShareButtonsPositioner>
      <IconButton
        href={`https://www.facebook.com/sharer/sharer.php?u=${href}`}
        target="_blank"
      >
        <FontAwesomeIcon icon={faFacebookSquare} />
      </IconButton>
      <IconButton
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${href}`}
        target="_blank"
      >
        <FontAwesomeIcon icon={faLinkedinIn} />
      </IconButton>
      <IconButton
        href={`https://www.twitter.com/intent/tweet?text=${title}%3A%20${href}`}
        target="_blank"
      >
        <FontAwesomeIcon icon={faTwitter} />
      </IconButton>
      <IconButton href={`mailto:?subject=${title}&body=${href}`}>
        <FontAwesomeIcon icon={faEnvelopeOpen} />
      </IconButton>
    </ShareButtonsPositioner>
  );
};

export default ShareButtons;
